export default __webpack_public_path__ + "static/media/sacaa-logo.9e74fb93.png";